var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { StyledError } from "../Form";
import { TextStyle } from "../TextStyle";
import * as S from "./DescriptionListItem.styled";
export var DescriptionListItem = function (props) {
    var term = props.term, description = props.description, _a = props.hasColon, hasColon = _a === void 0 ? false : _a, _b = props.hasBoldTerm, hasBoldTerm = _b === void 0 ? true : _b, termWidth = props.termWidth, error = props.error, rest = __rest(props, ["term", "description", "hasColon", "hasBoldTerm", "termWidth", "error"]);
    return (_jsxs(_Fragment, { children: [_jsxs(S.Wrap, __assign({ isInline: !!termWidth }, rest, { children: [_jsxs(S.Term, { termWidth: termWidth, children: [hasBoldTerm ? (_jsx(TextStyle, { variation: "strong", children: term })) : (term), hasColon && ":"] }), _jsx(S.Description, { children: description })] })), error && _jsx(StyledError, { children: error })] }));
};
